import { RepDisciplineReason, RepDisciplineType } from "../../models";

// Filter names, matching the GetDisciplines parameters
export const AGENT = "agent";
export const TYPES = "types";
export const ACTIVE = "active";
export const START_DATE_FROM = "startDateFrom";
export const START_DATE_TO = "startDateTo";
export const END_DATE_FROM = "endDateFrom";
export const END_DATE_TO = "endDateTo";
export const REASONS = "reasons";
export const TRAINING_IDS = "trainingIds";

export const typeOptions = [
	{ value: RepDisciplineType.Probation, label: "Probation" },
	{ value: RepDisciplineType.Suspension, label: "Suspension" },
	{ value: RepDisciplineType.Blocklist, label: "Blocklist" },
	{ value: RepDisciplineType.FeatureSuspension, label: "Feature Suspension" },
];

export const reasonOptions = [
	{ value: RepDisciplineReason.Complaint, label: "Complaint" },
	{ value: RepDisciplineReason.Onboarding, label: "Onboarding" },
	{ value: RepDisciplineReason.InternalReview, label: "Internal Review" },
	{ value: RepDisciplineReason.Alert, label: "Alert" },
];

export const activeOptions = [
	{ value: true, label: "Active" },
	{ value: false, label: "Ended" },
];
